import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Input } from './ui/input';
import { Button } from './ui/button';
import { Search, Trash2 } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

// Trainer-only: search the bundled free-exercise-db catalog (English names) and
// pin an animation to a library exercise, or remove a wrong auto-match.
export const AnimationPicker = ({ exercise, onChange }) => {
  const [query, setQuery] = useState(exercise.name_en || '');
  const [results, setResults] = useState(null);
  const [busy, setBusy] = useState(false);

  const runSearch = async (e) => {
    e?.preventDefault();
    if (!query.trim()) return;
    setBusy(true);
    try {
      const res = await axios.get(`${API_URL}/api/exercise-animations/search`, {
        params: { q: query }, withCredentials: true,
      });
      setResults(res.data);
    } catch (error) {
      console.error('Animation search failed:', error);
      toast.error('Nie udało się wyszukać animacji');
    } finally {
      setBusy(false);
    }
  };

  const pick = async (animationId) => {
    setBusy(true);
    try {
      const res = await axios.put(`${API_URL}/api/exercises/${exercise.id}/animation`,
        { animation_id: animationId }, { withCredentials: true });
      onChange(res.data);
      setResults(null);
      toast.success(animationId ? 'Animacja ustawiona' : 'Animacja usunięta');
    } catch (error) {
      console.error('Setting animation failed:', error);
      toast.error('Nie udało się zapisać animacji');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between gap-3">
        <label className="label-text text-[#A1A1A1] block">ANIMACJA (TRENER)</label>
        {exercise.animation_url && (
          <Button variant="ghost" size="sm" disabled={busy} onClick={() => pick(null)} className="text-[#A1A1A1] h-8">
            <Trash2 className="w-4 h-4 mr-1" /> Usuń
          </Button>
        )}
      </div>
      {exercise.animation_name && (
        <p className="text-xs text-[#A1A1A1]">Obecnie: {exercise.animation_name}</p>
      )}
      <form onSubmit={runSearch} className="flex gap-2">
        <Input value={query} onChange={e => setQuery(e.target.value)} placeholder="Szukaj po angielsku, np. goblet squat"
          className="bg-[#0A0A0A] border-[#2A2A2A] rounded-2xl text-white" data-testid="animation-search-input" />
        <Button type="submit" disabled={busy} className="rounded-2xl bg-[#1E1E1E] text-white border border-[#C9A84C]">
          <Search className="w-4 h-4" />
        </Button>
      </form>
      {results && (
        results.length === 0 ? (
          <p className="text-sm text-[#A1A1A1]">Brak wyników - spróbuj innej nazwy po angielsku.</p>
        ) : (
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 max-h-80 overflow-y-auto">
            {results.map(r => (
              <button key={r.id} type="button" disabled={busy} onClick={() => pick(r.id)}
                className="rounded-2xl border border-[#2A2A2A] hover:border-[#C9A84C] overflow-hidden text-left">
                <img src={r.frames[0]} alt={r.name} loading="lazy" className="w-full aspect-[3/2] object-cover" />
                <span className="block text-[0.7rem] text-[#A1A1A1] p-2 leading-tight">{r.name}</span>
              </button>
            ))}
          </div>
        )
      )}
    </div>
  );
};
